"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaMergeFactory = void 0;
const Factory = require("factory.ts");
const Mocks = require("../../../mocks");
exports.personaMergeFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    created_at: Mocks.dates.date2000,
    kept_persona_id: 1,
    merged_persona_id: 2,
    updated_at: Mocks.dates.date2000,
    user_id: 1
});
